const getDefaultData = (args) => {
    let tags = args.tags || [];
    tags.push('bot', 'www');

    if (args.orderNumber) {
        tags.push('sales_typ_vases');
    }

    return {
        tags: [...new Set(tags)],
        ...(args.additionalData && {
            additionalData: {
                ...args.additionalData
            }
        })
    };
};

export default getDefaultData;
